/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meow Mobile API
 * MeowStore 모바일 백엔드 API 명세
 * OpenAPI spec version: v1.0.0
 */

/**
 * 서버 경기 상태
 */
export type WorldcupMatchItemResponseStatus =
  (typeof WorldcupMatchItemResponseStatus)[keyof typeof WorldcupMatchItemResponseStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorldcupMatchItemResponseStatus = {
  SCHEDULED: 'SCHEDULED',
  BETTING_CLOSED: 'BETTING_CLOSED',
  LIVE: 'LIVE',
  FINISHED: 'FINISHED',
  CANCELLED: 'CANCELLED',
} as const;
